import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useUserStore } from "~/stores/userstore";

export default defineNuxtRouteMiddleware((to, _unused_from) => {
  console.debug("userIsOnOwnUserPage middleware");
  const userStore = useUserStore();

  // check route params userid equals userStore.authUserUuid
  const equalsOwnUuid = to.params.userid === userStore.authUserUuid;
  if (!equalsOwnUuid) {
    console.error(`You can only access your own user page.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Access denied`,
      body: `You can only access your own user page.`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
